import { render, staticRenderFns } from "./AssetDataTable.vue?vue&type=template&id=3b8f626b&scoped=true"
import script from "./AssetDataTable.vue?vue&type=script&lang=js"
export * from "./AssetDataTable.vue?vue&type=script&lang=js"
import style0 from "./AssetDataTable.vue?vue&type=style&index=0&id=3b8f626b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8f626b",
  null
  
)

export default component.exports